import { render, staticRenderFns } from "./ThePagination.vue?vue&type=template&id=53db94eb&scoped=true"
import script from "./ThePagination.vue?vue&type=script&lang=js"
export * from "./ThePagination.vue?vue&type=script&lang=js"
import style0 from "./ThePagination.vue?vue&type=style&index=0&id=53db94eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53db94eb",
  null
  
)

export default component.exports